import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/contexts/AuthContext'; // Updated import
import { GlobalContext } from './components/contexts/GlobalContext';
import { useState, useEffect, Suspense } from 'react';
import { useSocketEvent } from './components/useSocketEvents';

import { SocketProvider } from './components/contexts/SocketContext'; // Updated path
import { WatiSocketProvider } from './components/contexts/WatiSocketContext';
import { WatiChatProvider } from './components/contexts/WatiChatContext';
import { CSpinner } from '@coreui/react';
import DrawerNew from './components/DrawerNew';
import GetTitle from './components/GetTitle';

// Import Pages
import Landing from './components/Home/Landing';
import Login from './pages/Login';
import DashboardV2 from './pages/DashboardV2';
import Users from './pages/Users';
import QuerysetV2 from './pages/Querysetv2';
import WhatsApp from './pages/WhatsApp';
import WhatsappMessages from './pages/WhatsappMessages';
import Supplier from './pages/Supplier';
import Hrm from './pages/HRM';
import Reports from './pages/Reports';
import OverviewReport from './pages/Reports/Overview';
import SearchResults from './pages/SearchResults';
import NotFound from './components/Modals/NotFound';

const newVersionBannerKeyframes = `
  @keyframes srm-banner-slidein {
    from { transform: translateY(-100%); opacity: 0; }
    to   { transform: translateY(0);     opacity: 1; }
  }
  @keyframes srm-banner-pulse {
    0%, 100% { box-shadow: 0 2px 8px rgba(0,0,0,0.3), 0 0 0 0 rgba(255,255,255,0.4); }
    50%       { box-shadow: 0 2px 8px rgba(0,0,0,0.3), 0 0 0 8px rgba(255,255,255,0); }
  }
  @keyframes srm-rocket-bounce {
    0%, 100% { transform: translateY(0); }
    50%       { transform: translateY(-4px); }
  }
`;

const NewVersionBanner = () => {
  const [show, setShow] = useState(false);
  useSocketEvent('newVersionAvailable', () => setShow(true));
  if (!show) return null;
  return (
    <>
      <style>{newVersionBannerKeyframes}</style>
      <div
        onClick={() => window.location.reload(true)}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
          background: 'linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #1d4ed8 100%)',
          backgroundSize: '200% 100%',
          color: 'white',
          textAlign: 'center', padding: '10px 16px',
          cursor: 'pointer',
          animation: 'srm-banner-slidein 0.4s cubic-bezier(0.22,1,0.36,1) both, srm-banner-pulse 2.5s ease-in-out 0.5s infinite',
          userSelect: 'none',
        }}
      >
        <span style={{ animation: 'srm-rocket-bounce 1.2s ease-in-out infinite', display: 'inline-block', marginRight: 6 }}>🚀</span>
        <span style={{ fontSize: 14, fontWeight: 700 }}>New version of SRM available! Click here to get it.</span>
        <span style={{ fontSize: 12, fontWeight: 400, opacity: 0.88, marginLeft: 10 }}>New build includes bug fixes and new features!!</span>
      </div>
    </>
  );
};

// Create a wrapper component for authenticated routes
const AuthenticatedApp = () => {
  const { authState } = useAuth();

  return (
    <>
      <NewVersionBanner />
      <Routes>
        {!authState.isAuthenticated ? (
        <>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      ) : (
        <Route path="/" element={<DrawerNew title={<GetTitle />} />}>
          <Route path="/login" element={<Navigate to="/querysetv2" />} />
          <Route index element={<DashboardV2 />} />
          <Route path="/dashboard" element={<DashboardV2 />} />
          <Route path="/users" element={<Users />} />
          <Route path="/queryset" element={<QuerysetV2 />} />
          <Route path="/querysetv2" element={<QuerysetV2 />} />
          <Route path="/whatsapp" element={<WhatsApp />} />
          <Route path="/whatsapp_messages" element={<WhatsappMessages />} />
          <Route path="/suppliers" element={<Supplier />} />
          <Route path="/hrm" element={<Hrm />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports/overview" element={<OverviewReport />} />
          <Route path="/search_results" element={<SearchResults />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      )}
    </Routes>
    </>
  );
};

function App() {
  const [globalState, setGlobalState] = useState({
    messages: [],
    queryset: [],
    approval_messages: [],
  });

  return (
    <GlobalContext.Provider value={{ globalState, setGlobalState }}>
      <AuthProvider>
        <SocketProvider>
          <WatiSocketProvider>
            <Router>
              <WatiChatProvider>
                <Suspense fallback={<CSpinner color="primary" />}>
                  <AuthenticatedApp />
                </Suspense>
              </WatiChatProvider>
            </Router>
          </WatiSocketProvider>
        </SocketProvider>
      </AuthProvider>
    </GlobalContext.Provider>
  );
}

export default App;